window.Tether = require('tether');
window.jQuery = window.$ = require('jquery');

require('./compatibility');
require('slick-carousel');
require('bootstrap');
require('bootstrap-carousel-swipe');

import mitt from 'mitt'
import lozad from 'lozad';
import {
    initializeDesktopNavigationApp,
    initializeMobileNavigationApp,
    initializeSubcategoryNavigationApp
} from './vue-apps/navigation';
import {
    initializeGlobalBlockCart,
    initializeGlobalModalHelpers,
    initializePriceDisplayExplanationModal
} from "./vue-apps/modals";
import { initializeCopernicaUnsubscribeApp } from "./vue-apps/copernica";
import { initializeMyAccountApp } from "./vue-apps/my-account";
import { initializePasswordResetApp } from "./vue-apps/password-reset";

import {
    initializeAddressApp,
    initializeCheckoutApp,
    initializeCheckoutCartApp,
    initializeCheckoutPaymentApp,
    initializeContactApp,
    initializeOrderConfirmationApp
} from "./vue-apps/checkout";

import {
    initializeProductImageModalDesktopSlider,
    initializeProductImageModalMobileSlider,
    initializeProductImageSlider
} from "./javascript-global-functions/product-image-slider";

import {
    initializeProductReviewImageSlider
} from "./javascript-global-functions/review-image-slider";

import {
    initializeHomePagePopularBrandsSlider,
    initializeHomePageSlider
} from "./javascript-global-functions/home-page-slider";

import { initializeTipsAndAdviceSlider } from "./javascript-global-functions/tips-and-advice-slider";

import {
    initializeBardImageSlider
} from "./javascript-global-functions/bard-image-slider";

import { initializeSingleProductCombinations } from "./vue-apps/single-product";

import {
    initializeAlgoliaAnalytics,
    initializeAlgoliaRecommendationsApp,
    initializeAlgoliaSearchApp,
    initializeAlgoliaSearchCategoryApp,
    initializeAlgoliaSearchMobileApp
} from "./vue-apps/algolia-search";


import { updateDecidedABTests, isFeatureEnabled, sendDecidedABTestsToGA } from './helper/ab-test-helper';

const emitter = mitt();

window.EventBus = {
    $on: (eventName, callback) => emitter.on(eventName, callback),
    $emit: (eventName, value) => emitter.emit(eventName, value),
};

const observer = lozad();
observer.observe();

updateDecidedABTests();
sendDecidedABTestsToGA();

initializeProductImageSlider();
initializeProductImageModalDesktopSlider();
initializeProductImageModalMobileSlider();

initializeProductReviewImageSlider();

initializeHomePageSlider();
initializeHomePagePopularBrandsSlider();

initializeTipsAndAdviceSlider();

initializeBardImageSlider();

initializeGlobalModalHelpers();
initializeGlobalBlockCart();
initializePriceDisplayExplanationModal();

initializeDesktopNavigationApp();
initializeMobileNavigationApp();
initializeSubcategoryNavigationApp();

initializeMyAccountApp();

initializeCopernicaUnsubscribeApp();

initializeAlgoliaAnalytics();
initializeAlgoliaSearchApp();
initializeAlgoliaSearchMobileApp();
initializeAlgoliaSearchCategoryApp();
initializeAlgoliaRecommendationsApp();

initializeSingleProductCombinations();

initializeCheckoutCartApp();
initializeCheckoutPaymentApp();
initializeCheckoutApp();
initializeAddressApp();
initializeOrderConfirmationApp();
initializeContactApp();
initializePasswordResetApp();
